import './template_generic_hero.css'
